// Helper condivisi per il Blog
export const blogImage = (image_url) => {
  if (!image_url) return null;
  if (/^https?:\/\//i.test(image_url)) return image_url;
  return `${process.env.REACT_APP_BACKEND_URL}${image_url}`;
};

export const blogLang = (obj, base, lang) => {
  if (!obj) return "";
  return (lang === "en" ? obj[`${base}_en`] : obj[`${base}_it`]) || obj[`${base}_it`] || obj[`${base}_en`] || "";
};

export const formatBlogDate = (iso, lang) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : "it-IT", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
};
